import script from "./ImagesGridPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesGridPage.vue?vue&type=script&setup=true&lang=js"

import "./ImagesGridPage.vue?vue&type=style&index=0&id=67f87458&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f87458"]])

export default __exports__